"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardwareWalletError = exports.UserRejectedError = exports.RevealTokenError = exports.ContractCallError = exports.NonceUsedError = exports.InvalidPurchaseArgumentsError = exports.SoldOutError = exports.NotEnoughInventoryError = exports.TooManyRequestedError = exports.ContractDeactivatedError = exports.TransactionError = void 0;
var TransactionError = /** @class */ (function (_super) {
    __extends(TransactionError, _super);
    // Apparently instanceof error checks are broken in Typescript without this helper :(
    // https://www.dannyguo.com/blog/how-to-fix-instanceof-not-working-for-custom-errors-in-typescript/
    function TransactionError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, TransactionError.prototype);
        return _this;
    }
    return TransactionError;
}(Error));
exports.TransactionError = TransactionError;
var ContractDeactivatedError = /** @class */ (function (_super) {
    __extends(ContractDeactivatedError, _super);
    function ContractDeactivatedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ContractDeactivatedError.prototype);
        return _this;
    }
    return ContractDeactivatedError;
}(TransactionError));
exports.ContractDeactivatedError = ContractDeactivatedError;
var TooManyRequestedError = /** @class */ (function (_super) {
    __extends(TooManyRequestedError, _super);
    function TooManyRequestedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, TooManyRequestedError.prototype);
        return _this;
    }
    return TooManyRequestedError;
}(TransactionError));
exports.TooManyRequestedError = TooManyRequestedError;
var NotEnoughInventoryError = /** @class */ (function (_super) {
    __extends(NotEnoughInventoryError, _super);
    function NotEnoughInventoryError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, NotEnoughInventoryError.prototype);
        return _this;
    }
    return NotEnoughInventoryError;
}(TransactionError));
exports.NotEnoughInventoryError = NotEnoughInventoryError;
var SoldOutError = /** @class */ (function (_super) {
    __extends(SoldOutError, _super);
    function SoldOutError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, SoldOutError.prototype);
        return _this;
    }
    return SoldOutError;
}(TransactionError));
exports.SoldOutError = SoldOutError;
var InvalidPurchaseArgumentsError = /** @class */ (function (_super) {
    __extends(InvalidPurchaseArgumentsError, _super);
    function InvalidPurchaseArgumentsError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, InvalidPurchaseArgumentsError.prototype);
        return _this;
    }
    return InvalidPurchaseArgumentsError;
}(TransactionError));
exports.InvalidPurchaseArgumentsError = InvalidPurchaseArgumentsError;
var NonceUsedError = /** @class */ (function (_super) {
    __extends(NonceUsedError, _super);
    function NonceUsedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, NonceUsedError.prototype);
        return _this;
    }
    return NonceUsedError;
}(TransactionError));
exports.NonceUsedError = NonceUsedError;
var ContractCallError = /** @class */ (function (_super) {
    __extends(ContractCallError, _super);
    function ContractCallError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ContractCallError.prototype);
        return _this;
    }
    return ContractCallError;
}(TransactionError));
exports.ContractCallError = ContractCallError;
var RevealTokenError = /** @class */ (function (_super) {
    __extends(RevealTokenError, _super);
    function RevealTokenError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, RevealTokenError.prototype);
        return _this;
    }
    return RevealTokenError;
}(TransactionError));
exports.RevealTokenError = RevealTokenError;
var UserRejectedError = /** @class */ (function (_super) {
    __extends(UserRejectedError, _super);
    function UserRejectedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, UserRejectedError.prototype);
        return _this;
    }
    return UserRejectedError;
}(TransactionError));
exports.UserRejectedError = UserRejectedError;
var HardwareWalletError = /** @class */ (function (_super) {
    __extends(HardwareWalletError, _super);
    function HardwareWalletError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, HardwareWalletError.prototype);
        return _this;
    }
    return HardwareWalletError;
}(TransactionError));
exports.HardwareWalletError = HardwareWalletError;
